import { render, staticRenderFns } from "./HardwareLayout.vue?vue&type=template&id=ed87b5c2&scoped=true"
import script from "./HardwareLayout.vue?vue&type=script&lang=js"
export * from "./HardwareLayout.vue?vue&type=script&lang=js"
import style0 from "./HardwareLayout.vue?vue&type=style&index=0&id=ed87b5c2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed87b5c2",
  null
  
)

/* custom blocks */
import block0 from "./HardwareLayout.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports